import type { UserRole } from '@/types/user';

export type AppPage =
  | 'loginPage'
  | 'mainPage'
  | 'searchThingsPage'
  | 'searchByBillingUnitPage'
  | 'searchByAddressPage'
  | 'notAuthorizedPage'
  | 'authPopupCallback';

export type AppRoute = {
  name: string;
  path: string;
  restrictedToRoles?: UserRole[];
};

export enum Environment {
  local = 'local',
  dev = 'development',
  prod = 'production',
}
